'use strict';

/* javascript to increase browsing security */

// # Blocking opened window to access opener windows with javascript.
// Try this: https://mathiasbynens.github.io/rel-noopener/
var el = document.querySelectorAll('a[target=_blank]');
for (var i = 0; i < el.length; i++) {
  el[i].setAttribute('rel', 'noopener noreferrer nofollow');
}

// Rewrite soring function to avoid `this` pointing to `window`
Array.prototype.sort = function (sort) {
  return function (callback) {
    return this == window ? null : callback ? sort.call(this, function (a, b) {
      return callback(a, b);
    }) : sort.call(this);
  };
}(Array.prototype.sort);